import "..\\..\\..\\..\\..\\src\\index.css";
import BlockQuote from "..\\..\\..\\..\\..\\src\\components\\BlockQuote";
import * as React from 'react';
export default {
  BlockQuote,
  React
};